define('taoQtiItem/qtiXmlRenderer/renderers/choices/GapText',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'gapText',
        template : tpl
    };
});
